import {AfterViewInit, Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {BankInteractor} from "../../interactors/bank.interactor";
import {BankAccountInteractor} from "../../interactors/bank-account.interactor";
import {UserInteractor} from "../../interactors/user.interactor";
import {map, startWith} from 'rxjs/operators';
import {Observable} from "rxjs";
import {BankDetailsComponent} from "../bank-details.component";
import {LoanApplicationInteractor} from "../../interactors/loan-application.interactor";

@Component({
    selector: 'app-bank-details-by-name',
    templateUrl: './bank-details-by-name.component.html',
    styleUrls: ['../../loan-application-flow-component/application-flow.css', './bank-details-by-name.component.css']
})
export class BankDetailsByNameComponent extends BankDetailsComponent implements OnInit, AfterViewInit {
    public bankList: string[];
    public cities: string[];
    public bankBranches: string[];
    public filteredCities: Observable<string[]>;
    public filteredBankBranches: Observable<string[]>;
    public filteredBankNames: Observable<string[]>;
    loadingCities: boolean;
    loadingBranches: boolean;

    constructor(formBuilder: FormBuilder, protected bankInteractor: BankInteractor, protected bankAccountInteractor: BankAccountInteractor, protected userInteractor: UserInteractor, loanApplicationInteractor: LoanApplicationInteractor) {
        super(bankInteractor, bankAccountInteractor, userInteractor, loanApplicationInteractor);

        this.searchBankFormGroup = formBuilder.group({
            ifscCode: new FormControl({value: null, disabled: true}),
            bankName: new FormControl(null, Validators.required),
            bankCity: new FormControl(null, Validators.required),
            bankBranchName: new FormControl(null, Validators.required)
        });
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit();

        this.bankList = await this.bankInteractor.getBankNames();
        this.filteredBankNames =
            this.searchBankFormGroup.controls.bankName.valueChanges
                .pipe(startWith(''), map(value => this.filterBankNames(value)));
    }

    protected prepopulate(): void {
        super.prepopulate();

        if (this.bankAccount) {
            this.searchBankFormGroup.controls.bankBranchName.disable();
            this.searchBankFormGroup.controls.bankCity.disable();
        }
    }

    async onBankNameSelected(): Promise<void> {
        this.clearFieldsForBankName();
        const selectedBankName = this.searchBankFormGroup.controls.bankName.value;
        this.loadingCities = true;
        this.cities = await this.bankInteractor.getCitiesbyBankName(selectedBankName);
        this.loadingCities = false;
        this.searchBankFormGroup.controls.bankBranchName.enable();
        this.searchBankFormGroup.controls.bankCity.enable();
    }

    async onCitySelected(): Promise<void> {
        this.clearFieldsForBankCity();
        const selectedBankName = this.searchBankFormGroup.controls.bankName.value;
        const selectedCityName = this.searchBankFormGroup.controls.bankCity.value;
        this.loadingBranches = true;
        this.bankBranches = await this.bankInteractor.getBankBranches(selectedBankName, selectedCityName);
        this.loadingBranches = false;
        this.filteredBankBranches =
            this.searchBankFormGroup.controls.bankBranchName.valueChanges
                .pipe(startWith(''), map(value => this.filterBankBranchNames(value)));
    }
    public getCityName(){
     let citySearch = this.searchBankFormGroup.controls.bankCity.value;

     if(citySearch?.length < 3) {
        this.filteredCities = null;
     }
     if(citySearch?.length === 3) {
        this.filteredCities = this.searchBankFormGroup.controls.bankCity.valueChanges
            .pipe(startWith(citySearch), map(value => this.filterCityNames(value)));
        }
    }

    async onBankBranchSelected(): Promise<void> {
        this.clearFieldsForBankBranch();
        const selectedBankName = this.searchBankFormGroup.controls.bankName.value;
        const selectedBranchName = this.searchBankFormGroup.controls.bankBranchName.value;

        const ifscCode = await this.bankInteractor.getIfsc(selectedBranchName, selectedBankName);
        this.searchBankFormGroup.controls.ifscCode.setValue(ifscCode);
        this.showAccountDetailsSection = true;
    }

    protected clearFieldsForBankName(): void {
        this.searchBankFormGroup.controls.bankCity.reset();
        this.clearFieldsForBankCity();
    }

    protected clearFieldsForBankCity(): void {
        this.searchBankFormGroup.controls.bankBranchName.reset();
        this.clearFieldsForBankBranch();
    }

    protected clearFieldsForBankBranch(): void {
        this.searchBankFormGroup.controls.ifscCode.reset();
        this.clearBankAccountFields();
    }

    private filterBankNames(val: string): string[] {
        return this.bankList.filter(bankName => bankName.toLowerCase().startsWith(val.toLowerCase()));
    }

    private filterCityNames(val: string): string[] {
        return this.cities.filter(city => city.toLowerCase().startsWith(val.toLowerCase()));
    }

    private filterBankBranchNames(val: string): string[] {
        return this.bankBranches.filter(branch => branch.toLowerCase().startsWith(val.toLowerCase()));
    }
}
